import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'timestamp',
  standalone: true,
})
export class TimestampPipe implements PipeTransform {
  transform(secondsToConvert: number): string {
    const hours = Math.floor(secondsToConvert / 3600)
    const minutes = Math.floor((secondsToConvert % 3600) / 60)
    const seconds = Math.floor(secondsToConvert % 60)
    const secondsString = seconds.toString().padStart(2, '0')
    const minutesString = minutes.toString().padStart(2, '0')
    const hoursString = hours.toString().padStart(2, '0')
    if (hours > 0) {
      return `${hoursString}:${minutesString}:${secondsString}`
    }
    return `${minutesString}:${secondsString}`
  }
}
